import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { LookupResponse } from '@core/models/common.model';
import { CreateDependantRequest, DependantResponse } from '../../employee.model';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { toNullableDateString } from '@shared/utils/date-utils';
import { nullIfBlank } from '@shared/utils/payload-utils';

@Component({
  selector: 'dependant-form',
  imports: [ReactiveFormsModule, ...SharedMaterialUIModule],
  templateUrl: './dependant-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DependantFormComponent {
  private readonly formBuilder = inject(FormBuilder);

  readonly dependantTypes = input<LookupResponse[]>([]);
  readonly titles = input<LookupResponse[]>([]);
  readonly initialValue = input<DependantResponse | null>(null);
  readonly saving = input(false);

  readonly submitted = output<CreateDependantRequest>();

  readonly dependantForm = this.formBuilder.group({
    dependantTypeId: ['', Validators.required],
    titleId: [''],
    firstName: ['', Validators.required],
    surname: ['', Validators.required],
    dateOfBirth: [''],
    contactNumber: [''],
    emailAddress: ['', Validators.email],
  });

  constructor() {
    effect(() => {
      const initialValue = this.initialValue();
      if (!initialValue) {
        return;
      }

      this.dependantForm.patchValue({
        dependantTypeId: initialValue.dependantTypeId,
        titleId: initialValue.titleId ?? '',
        firstName: initialValue.firstName,
        surname: initialValue.surname,
        dateOfBirth: initialValue.dateOfBirth ?? '',
        contactNumber: initialValue.contactNumber ?? '',
        emailAddress: initialValue.emailAddress ?? '',
      });
    });
  }

  protected onSubmit(): void {
    if (this.dependantForm.invalid) {
      this.dependantForm.markAllAsTouched();
      return;
    }

    const value = this.dependantForm.getRawValue();
    this.submitted.emit({
      dependantTypeId: (value.dependantTypeId ?? '').trim(),
      titleId: nullIfBlank(value.titleId),
      firstName: (value.firstName ?? '').trim(),
      surname: (value.surname ?? '').trim(),
      dateOfBirth: toNullableDateString(value.dateOfBirth),
      contactNumber: nullIfBlank(value.contactNumber),
      emailAddress: nullIfBlank(value.emailAddress),
    });
  }
}
